import { render } from "./recipient-form.vue?vue&type=template&id=d9b1d128"
import script from "./recipient-form.vue?vue&type=script&lang=js"
export * from "./recipient-form.vue?vue&type=script&lang=js"

import "./recipient-form.vue?vue&type=style&index=0&id=d9b1d128&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__